import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = () => {
  return (
    <div className={styles.container} style={{ backgroundImage: `url("${getImageFromS3(
        'images/unsubscribe/unsubscribe-bg.png'
      )}")` }}>
      <p className={styles.title}>Email підтверджено!</p>
      <p className={styles.description}>
        Дякуємо, що підтвердив(-ла) електронну адресу
      </p>
      <img src={getImageFromS3('images/unsubscribe/img.png')} alt="image" />
    </div>
  );
};

export default HomeScreen;
